<template>
  <AddCreditCardComponent />
</template>

<script lang="ts">
import AddCreditCardComponent from "@/components/CreditCards/AddCreditCard.vue";
import { defineComponent } from "vue";

const componentName = "AddCreditCardRoute";

export default defineComponent({
  name: componentName,
  components: { AddCreditCardComponent },
});
</script>
